document.addEventListener('DOMContentLoaded', () => {
  const run = document.getElementsByClassName('date-range');

  if (run.length > 0) {
    Array.from(run).forEach((input) => {

      const start = input.dataset.start;
      const end = input.dataset.end;

      const picker = new easepick.create({
        element: input,
        format: 'MM-DD-YYYY',
        css: [
          'https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css',
          `${window.location.origin}/easepick/index.css`
        ],
        zIndex: 10,
        plugins: easepickPlugins,
      });

      picker.setDateRange(start, end);

      picker.on('select', () => {
        const datesPicked = new CustomEvent('datesPicked', {
          detail: {
            start: picker.getStartDate(),
            end: picker.getEndDate()
          }
        });

        input.dispatchEvent(datesPicked);

        setTimeout(() => {
          picker.hide();
        }, 0);
      });
    });
  }
});
